import { fetchFinlinkAccounts, fetchAccountTransactions } from '../../services/API';
import formatDate from 'date-fns/format';

export const getFinlinkAccounts = async ({ commit }, page = 1) => {
    commit('FETCHING_FINLINK_ACCOUNTS', true);

    try {
        const res = await fetchFinlinkAccounts(page);
        const accounts = res.data.map(account => {
            account.lastUpdated = formatDate(account.updatedAt, 'MMMM DD, YYYY');

            return account;
        });

        commit('FETCHING_FINLINK_ACCOUNTS', false);
        commit('SET_FINLINK_ACCOUNTS', accounts);
    } catch (error) {
        commit('FETCHING_FINLINK_ACCOUNTS', false);
        console.log("Error fetching finlink accounts:", error);
    }
}

export const setSelectedFinlinkAccount = ({ commit }, accountId) => {
    commit('SET_SELECTED_FINLINK_ACCOUNT', accountId);
}

export const getFinlinkAccountTransactions = async ({ state, commit }, page = 1) => {
    if(!state.selectedFinlinkAccountId)
        return console.log("No selected finlink account");
        
    commit('FETCHING_FINLINK_ACCOUNT_TRANSACTIONS', true);

    try {
        let {data, pagination} = await fetchAccountTransactions(state.selectedFinlinkAccountId, page);
        const transactions = data.map(transaction => {
            transaction.date = formatDate(transaction.createdAt, 'MMMM DD, YYYY');
            transaction.time = formatDate(transaction.createdAt, 'HH:mm');

            if(transaction.accountTransactions && transaction.accountTransactions.length){
                const accountTransactionDetails = transaction.accountTransactions[0];
                if(accountTransactionDetails){
                  const { fromAccount, toAccount } = accountTransactionDetails;
                  transaction = {
                    ...transaction, fromAccount, toAccount
                  }
                }
            }

            return transaction;
        });

        commit('FETCHING_FINLINK_ACCOUNT_TRANSACTIONS', false);
        commit('SET_FINLINK_ACCOUNT_TRANSACTIONS', {data: transactions, pagination});
    } catch (error) {
        commit('FETCHING_FINLINK_ACCOUNT_TRANSACTIONS', false);
        console.log("Error fetching supported banks:", error);
    }
}